import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions/auth';
import Login from './Login';
import Home from './Home';

class Router extends Component {
  componentWillMount() {
    this.props.actions.init();
  }

  render() {
    const { userStatus } = this.props;
    if (userStatus !== 'USER_LOGIN') {
      return <Login />;
    }
    return <Home />;
  }
}

function mapStateToProps(state) {
  return {
    userStatus: state.auth.userStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Router);



// WEBPACK FOOTER //
// ./src/containers/Router.jsx